/* @flow */
import {type Store} from '../../reducers/index';
import cookieUtils from '../../utils/cookieUtils';
import {LOCATION_COOKIE} from '../../utils/locationData';
import {getUri} from '../../utils/routerUtils';

type Action = {
    type: string,
    // TODO Add flow type to `payload` when redux-little-router upgraded to ^15.1.0
    payload: {pathname: string, search?: string}
};

export default function setLastSearchUrl(
    store: Store,
    {payload: {pathname, search}}: Action
) {
    const haStatePersistCookie = cookieUtils.readCookie(LOCATION_COOKIE);
    haStatePersistCookie.lastSearchUrl = getUri({pathname, search});
    cookieUtils.writeCookie(LOCATION_COOKIE, haStatePersistCookie);
}
